module.exports = __webpack_public_path__ + "img/voileetmoteur-header.aa24dbb9.jpg";